import React, { useContext } from 'react';
import { AutoFlex, Flex, Spacer, RadioButton, AsNumber } from '@adserve/adserve-react-components';
import { inputStyle, labelStyle } from '../../../styles';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { symbolContainerStyle, symbolStyle } from '../RadioInputStyles';

const RadioInput = ({
    id,
    name,
    disabled = false,
    selected = false,
    value,
    title,
    onClick,
    isCurrency = false,
    onChange,
    symbol = '',
    onBlur,
    invalid,
    ...props
}) => {
    const { formatCurrency, formatNumber } = useContext(SystemSettingsContext);

    return (
        <Flex centreVertical>
            <div style={{ width: 16, marginTop: 20 }}>
                <RadioButton
                    id={`${id}`}
                    checkStyle={{ marginTop: 0 }}
                    disabled={disabled}
                    value={selected}
                    onClick={onClick}
                />
            </div>
            <Spacer width={6} />

            <AutoFlex>
                {isCurrency ? (
                    <AsNumber
                        id={`${id}`}
                        name={name}
                        title={title}
                        labelStyle={labelStyle}
                        inputStyle={{
                            ...inputStyle,
                            backgroundColor: selected && invalid ? 'rgb(255, 243, 243)' : 'rgb(255, 253, 244)',
                            border: selected && invalid ? '1px solid rgb(196,6,6)' : '1px solid rgb(215,215,215)',
                            width: 90,
                            ...(symbol ? { textAlign: 'left', paddingLeft: 34 } : {})
                        }}
                        value={value}
                        disabled={!selected || disabled}
                        allowFloat={true}
                        formatCurrency={formatCurrency}
                        onChange={onChange}
                        onBlur={onBlur}
                        {...props}
                    />
                ) : (
                    <AsNumber
                        id={`${id}`}
                        name={name}
                        title={title}
                        labelStyle={labelStyle}
                        inputStyle={{
                            ...inputStyle,
                            backgroundColor: !selected
                                ? 'rgb(247,247,247)'
                                : invalid
                                ? 'rgb(255, 243, 243)'
                                : 'rgb(255, 253, 244)',
                            border: !selected
                                ? '1px solid  rgb(215,215,215)'
                                : invalid
                                ? '1px solid rgb(196,6,6)'
                                : '1px solid rgb(215,215,215)',
                            width: 90,
                            ...(symbol ? { textAlign: 'left', paddingLeft: 34 } : {})
                        }}
                        value={value}
                        allowFloat={true}
                        disabled={!selected || disabled}
                        onChange={onChange}
                        formatNumber={formatNumber}
                        onBlur={onBlur}
                        {...props}
                    />
                )}
            </AutoFlex>
            {symbol && (
                <div style={symbolContainerStyle}>
                    <span style={symbolStyle}>{symbol}</span>
                </div>
            )}
        </Flex>
    );
};

export default RadioInput;
